import { fetchPageDataFactory } from 'actions/pageActionsV4';
export var UserAddressActions;
(function (UserAddressActions) {
    UserAddressActions["REQUEST"] = "GET_USER_ADDRESS_REQUEST";
    UserAddressActions["SUCCESS"] = "GET_USER_ADDRESS_SUCCESS";
    UserAddressActions["ERROR"] = "GET_USER_ADDRESS_ERROR";
})(UserAddressActions || (UserAddressActions = {}));
export const getUserAddressAction = fetchPageDataFactory(UserAddressActions.REQUEST, UserAddressActions.SUCCESS, UserAddressActions.ERROR);
